import { render } from "./TanaoroshiAddJanDialog.vue?vue&type=template&id=10fd93a8"
import script from "./TanaoroshiAddJanDialog.vue?vue&type=script&lang=js"
export * from "./TanaoroshiAddJanDialog.vue?vue&type=script&lang=js"

import "./TanaoroshiAddJanDialog.vue?vue&type=style&index=0&id=10fd93a8&lang=css"

import exportComponent from "C:\\Users\\t.chida\\Desktop\\hybrid_inventory_baroque\\hybrid_inventory_web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__